import { getOwaCanaryCookie } from 'owa-service/lib/canary';
import CreateAttachmentResponse from 'owa-service/lib/contract/CreateAttachmentResponse';
import ItemId from 'owa-service/lib/contract/ItemId';
import createAttachmentJsonRequest from 'owa-service/lib/factory/createAttachmentJsonRequest';
import createAttachmentRequest from 'owa-service/lib/factory/createAttachmentRequest';
import fileAttachment from 'owa-service/lib/factory/fileAttachment';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

const CREATE_ATTACHMENT_URL = '/owa/service.svc/CreateAttachmentFromLocalFile';

export default function createFileAttachment(
    file: Blob,
    fileName: string,
    parentItemId: ItemId
): Promise<CreateAttachmentResponse> {
    const attachment = fileAttachment({
        Name: fileName,
        Size: file.size,
        ContentType: file.type,
        IsInline: false,
        Content: '',
    });

    const attachmentTempId = fileName + '-' + new Date().toString();

    const requestBody = createAttachmentRequest({
        ParentItemId: parentItemId,
        Attachments: [attachment],
        RequireImageType: attachment.IsInline,
        IncludeContentIdInResponse: attachment.IsInline,
        ClientSupportsIrm: false,
        CancellationId: attachmentTempId,
    });

    const jsonRequest = createAttachmentJsonRequest({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    });

    const serializedRequest: string = JSON.stringify(jsonRequest);

    return fetch(CREATE_ATTACHMENT_URL, {
        method: 'POST',
        headers: <any>{
            'X-OWA-Action': 'CreateAttachmentFromLocalFile',
            'X-OWA-CANARY': getOwaCanaryCookie(),
            'X-OWA-UrlPostData': encodeURIComponent(serializedRequest),
        },
        body: file,
        credentials: 'include',
    }).then(response => {
        return response.json();
    });
}
